<template>
  <BaseDialog
    v-model="showDialog"
    :title="title"
    :subtitle="subtitle"
    :dialogIcon="icon"
    scrollable
  >
    <template v-slot>
      <div class="mb-4" v-for="(project, index) in projects" :key="index">
        <ProjCard
          :title="project.name"
          :imageSrc="project.defaultImage"
          :checkedIn="true"
          @click="clickProject(project)"
        />
      </div>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import ProjCard from "@/components/shared/cards/ProjCard.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    projects: {
      type: Array,
    },
    title: {
      type: String,
      default: "Bytt prosjekt",
    },
    subtitle: {
      type: String,
      default: "3 prosjekter tilgjengelig",
    },
    icon: {
      type: String,
      default: "mdi-home-switch",
    },
  },
  methods: {
    clickProject(project) {
      this.$emit("click", project);
      // this.$router.push({ name: "Project", params: { id: project.id } });
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    BaseDialog,
    ProjCard,
  },
});
</script>
